<div class="progress-spinner-container" *ngIf="displayProgress">
  <div class="lds-css ng-scope">
    <div style="width:100%;height:100%" class="lds-interwind lds-ball2">
      <div></div>
      <div></div>
    </div>
  </div>
</div>